import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-decision-maker-details',
		path: '/admin/decision-makers/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-decisionMaker-details" */ './index'), {
			exportName: 'DecisionMakerDetails',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
